import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HttpClientModule } from '@angular/common/http';
import { TranslateModule } from '@ngx-translate/core';
import { SkeletonComponent } from './skeleton.component';
import { VersionOverlayComponent } from './version-overlay.component';
import { DataChartComponent } from './data-chart.component';
import { CommitBarComponent } from './commit-bar.component';

@NgModule({
  declarations: [SkeletonComponent, VersionOverlayComponent, DataChartComponent, CommitBarComponent],
  imports: [CommonModule, HttpClientModule, TranslateModule],
  exports: [SkeletonComponent, VersionOverlayComponent, DataChartComponent, CommitBarComponent, TranslateModule],
})
export class SharedModule {}
